export default from './ResetPassword';



// WEBPACK FOOTER //
// ./src/components/LoanOfficerSettings/components/ResetPassword/index.js